module.exports = __webpack_public_path__ + "static/media/arrows-dashboard.865b0e28.png";